module.exports = __webpack_public_path__ + "static/media/NIFTY-MIDCAP50.750df5d0.txt";